import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Flex, Box, Text, Heading } from 'pcln-design-system'

const FlexExtended = styled(Flex)`
  font-family: Montserrat;
  box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.08), 0 4px 4px 0 rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
`

const PromoUnit = props => (
  <FlexExtended m={2} p={4}>
    <Box>
      {props.headingText && (
        <Heading
          textAlign='center'
          pb={2}
          bold
          fontSize={props.headingFontSize}
          color={props.headingColor}
        >
          {props.headingText}
        </Heading>
      )}
      {props.bodyText && (
        <Text
          textAlign='center'
          pb={3}
          fontSize={props.bodyFontSize}
          color={props.bodyColor}
        >
          {props.bodyText}
        </Text>
      )}
      {props.children}
    </Box>
  </FlexExtended>
)

PromoUnit.defaultProps = {
  headingText: '',
  bodyText: '',
  headingFontSize: 5,
  bodyFontSize: 3,
  headingColor: 'text',
  bodyColor: '#596b7d'
}

PromoUnit.propTypes = {
  headingText: PropTypes.string,
  bodyText: PropTypes.string,
  headingFontSize: PropTypes.number,
  bodyFontSize: PropTypes.number,
  headingColor: PropTypes.string,
  bodyColor: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
}

export default PromoUnit
